<div
  id="side-bar"
  class="side-bar w-12 min-h-screen"
  [ngClass]="
    this.contentLayout.sideBarComponentToLoad === 'SidebarNotificationsComponent' ? 'sm:w-30rem' : 'sm:w-25rem'
  "
  [class.side-bar-active]="contentLayout.sideBarActive"
  (click)="$event.stopPropagation()"
>
  <div class="side-bar-content shadow-8" [ngSwitch]="this.contentLayout.sideBarComponentToLoad">
    <p-button
      styleClass="p-button-rounded p-button-danger p-button-text side-bar-close"
      icon="pi pi-times"
      (click)="contentLayout.toggleSidebarDisplay($event)"
    ></p-button>

    <app-side-bar-notifications *ngSwitchCase="'SidebarNotificationsComponent'"></app-side-bar-notifications>
    <app-side-bar-theme-config *ngSwitchCase="'SidebarThemeConfigComponent'"></app-side-bar-theme-config>
    <app-side-bar-profile *ngSwitchCase="'SidebarProfileComponent'"></app-side-bar-profile>
  </div>
</div>
